import PropTypes from "prop-types"
import React from "react"
import Player from "./Player"
import Upload from "./Upload"

const videoEditorDefaultPropVideo = {}

const VideoEditor = (props) => {
  props = {
    video: videoEditorDefaultPropVideo,
    ...props
  }

  const [video, setVideo] = React.useState(props.video)

  React.useEffect(() => {
    if (props.video.id !== video.id) {
      setVideo(props.video)
    }
  }, [props.video])

  const videoReady = !!video
  return !videoReady ? (
    <Upload
      onUpload={(video) => setVideo(video)}
      onVideoCreated={(video) => setVideo(video)}
    />
  ) : (
    <Player
      video={video}
      contextKey={props.contextKey}
      coverImage={props.coverImage}
      controls={props.controls}
      allowDownload={props.allowDownload}
    />
  )
}

VideoEditor.propTypes = {
  video: PropTypes.object,
  allowDownload: PropTypes.bool,
  coverImage: PropTypes.string,
  controls: PropTypes.bool,
  contextKey: PropTypes.string
}

export default VideoEditor
